import { methodGet, methodPost, methodDelete, methodPut, methodPatch } from './methods';
import { API_INFO } from '../constants';

const url_base = API_INFO + 'products/';

export async function getMerchandising() {
  const url = API_INFO + 'products/listas/get-lists-merchandising/';
  return methodGet(url, {});
}

export async function getDetailList(slug) {
  const url = API_INFO + 'products/listas/';
  return methodGet(url, slug);
}

export async function getElementsList(id, query) {
  const apiUrl = API_INFO + `products/lists/${id}/products/`;
  return methodGet(apiUrl, query);
}

export async function getInfantilProductsByList(query) {
  const apiUrl = API_INFO + 'products/lists/products_infantil/';
  return methodGet(apiUrl, query);
}

export const favorites = () => {
  const url = url_base + 'listas/saved-user';
  return methodGet(url);
};

export async function getAllLists(payload) {
  const url = API_INFO + 'products/lists/';
  return methodGet(url, payload);
}

export async function getAllListsNotPaginated(query) {
  const url = API_INFO + 'products/lists/all-lists-not-paginated';
  return methodGet(url, query);
}

export async function createList(payload) {
  const url = API_INFO + 'products/lists/';
  return methodPost(url, payload);
}

export async function listTypes() {
  const url = API_INFO + 'products/lists/types';
  return methodGet(url, {});
}

export async function editList(payload, id) {
  const url = API_INFO + `products/lists/${id}/`;
  return methodPatch(url, payload);
}

export async function getList(id) {
  const url = API_INFO + `products/lists/${id}/`;
  return methodGet(url);
}

export async function deleteList(id) {
  const url = API_INFO + `products/lists/${id}/`;
  return methodDelete(url);
}

export async function createListProduct(payload) {
  const url = API_INFO + 'products/list-elements/';
  return methodPost(url, payload);
}

export async function getListProduct(payload) {
  const url = API_INFO + `products/list-elements/`;
  return methodGet(url, payload);
}

export async function editListProduct(payload, id) {
  const url = API_INFO + `products/list-elements/${id}/`;
  return methodPut(url, payload);
}

export async function deleteListProduct(id) {
  const url = API_INFO + `products/list-elements/${id}/`;
  return methodDelete(url);
}
